import { z } from 'zod'
import { parseTime } from '../WeekGrid/timeMath.ts'

const timeRegex = /^\d{1,2}:\d{2}$/

export const editorSchema = z
  .object({
    start: z.string(),
    end: z.string(),
    workingHours: z.boolean(),
    scope: z.enum(['date', 'recurring']),
  })
  .superRefine((data, ctx) => {
    // Off-day: time inputs are disabled in the UI, skip validation.
    if (!data.workingHours) return

    if (!timeRegex.test(data.start)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['start'], message: 'Invalid time' })
      return
    }
    if (!timeRegex.test(data.end)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['end'], message: 'Invalid time' })
      return
    }
    const s = parseTime(data.start)
    const e = parseTime(data.end)
    if (s === null) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['start'], message: 'Invalid time' })
      return
    }
    if (e === null) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['end'], message: 'Invalid time' })
      return
    }
    if (e <= s) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['end'],
        message: 'End must be after start',
      })
    }
  })

export type EditorFormValues = z.infer<typeof editorSchema>
